import styled from "styled-components";
import theme from "../../theme/theme";

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 20px;
  align-items: center;
  gap: 20px;
  @media (max-width: 400px) {
    padding: 10px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

export const Category = styled.h3`
  font-size: 1.2rem;
  font-weight: 400;
  color: ${theme.color.stone};
  // color: ${(props) => (props.color ? `${props.color}` : `${theme.color.stone}`)};
  margin-bottom: 5px;
  margin-top: 0;
  @media (max-width: 400px) {
    font-size: 0.8rem;
  }
  @media (min-width: 1000px) and (max-width: 1300px) {
    font-size: 1rem;
  }
`;

export const Content = styled.p`
  font-size: 2rem;
  font-weight: 700;
  color: ${theme.color.black};
  margin: 0 0 0 15px;
  @media (max-width: 400px) {
    font-size: 1.4rem;
  }
  @media (min-width: 1000px) and (max-width: 1300px) {
    font-size: 1.6rem;
  }
`;

export const Card = styled.div`
  background: ${(props) => (props.color ? `linear-gradient(0deg, ${props.color} -60%, ${theme.color.white} 60%);` : "#fff")};
  // background-color: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
  display: table;
  // width: 28em;
  width: 42%;
  height: auto;
  min-width: 16em;
  // max-width: 28em;
  padding: 30px;
  color: #ffff;
  font-family: "Inter", sans-serif;
  @media (max-width: 400px) {
    width: 100%;
  }

  @media (min-width: 500px) and (max-width: 800px) {
    width: 100%;
  }

  @media (min-width: 1300px) and (max-width: 1500px) {
    width: 40%;
  }

  @media (min-width: 1000px) and (max-width: 1300px) {
    width: 38%;
  }
`;
